var map = {
	"./coworking_workplace_icon.svg": 63169,
	"./crane.svg": 88832,
	"./done.svg": 93051,
	"./feedback.svg": 98500,
	"./header-promo/info.svg": 56013,
	"./here.svg": 55644,
	"./invalid-name.svg": 23581,
	"./keys.svg": 79259,
	"./phone.svg": 3245,
	"./project.svg": 89133,
	"./rent-helper/form.svg": 49585,
	"./rent-helper/phone.svg": 40614,
	"./showel.svg": 74036,
	"./shpatel.svg": 23304,
	"./worker.svg": 74374
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36745;